import { WorkspaceRole, WorkspaceRolePolicy } from "hooks/useWorkspace/workspace.types";

export const isWorkspaceRole = (role: string): role is WorkspaceRole =>
  Object.values(WorkspaceRole).includes(role as WorkspaceRole);

export const resolvePermissionsFromRole = (role: string | null): string[] => {
  if (!role) {
    return [];
  }

  const normalizedRole = role.toLowerCase();
  if (!isWorkspaceRole(normalizedRole)) {
    return [];
  }

  return [...WorkspaceRolePolicy[normalizedRole]];
};
